import store from '@/store';
import Segment from '@/Segment';
import Intercom from '@/Intercom';
import { CHAT_POPUP_SEEN_KEY, ONBOARDING_INTRO_QUESTIONS } from '@/constants/chat';
import Chatbot from './Chatbot.vue';
import ChatPopup from './ChatPopup.vue';

// showIntro shows the one-time explainer popup first, which then forwards to the chatbot.
// Support entry points skip it — the user already asked for help.
export default function openAssistant({
  initiator,
  initialMessage = null,
  showIntro = false,
  utmCampaign = null,
  suggestedQuestions = null,
  conversationId = null,
  startWithTeam = false,
  startWithTeamFallback = null,
}) {
  Segment.trackUserInteraction('AIChatbot_Opened', {
    source: initiator,
    ...(utmCampaign ? { utm_campaign: String(utmCampaign) } : {}),
  });
  if (showIntro && !startWithTeam && !localStorage.getItem(CHAT_POPUP_SEEN_KEY)) {
    store.dispatch('modalRootStore/openModal', {
      component: ChatPopup,
      props: { initialMessage, initiator, suggestedQuestions },
    });
    return;
  }
  store.dispatch('modalRootStore/openModal', {
    component: Chatbot,
    props: {
      initialMessage,
      initiator,
      suggestedQuestions,
      initialConversationId: conversationId,
      startWithTeam,
      startWithTeamFallback,
    },
    popupAlignment: 'menu',
    trackVisualViewport: true,
  });
}

// Onboarding entry points are behind the assistant_onboarding flag while we test them.
// With the flag off, screens that already had an Intercom button keep opening Intercom;
// the buttons this project adds hide themselves (see the OnboardingAssistantButton mixin).
export function openOnboardingAssistant({ initiator, initialMessage = null }) {
  if (!store.getters['featureFlags/onboardingAssistant']) {
    Intercom.show();
    return;
  }
  openAssistant({
    initiator,
    initialMessage,
    suggestedQuestions: ONBOARDING_INTRO_QUESTIONS,
  });
}
